import { Modal as ModalModule } from 'common';
import isFunction from 'lodash/isFunction';
import React from 'react';

const { Modal, ModalButtonActionType } = ModalModule;

const CancelPickupModal = ({ data: { onCancelPickupCallback }, modalId }) => {
	const onClickCancelPickupButton = closeModal => {
		if (isFunction(onCancelPickupCallback)) {
			onCancelPickupCallback();
		}

		closeModal();
	};

	const primaryButton = {
		type: ModalButtonActionType.Ok,
		text: 'Cancel Pickup',
		onClick: onClickCancelPickupButton,
		dataqa: 'cancel-pickup-cancel-button',
	};

	const secondaryButton = {
		type: ModalButtonActionType.Cancel,
		text: "Don't Cancel",
		dataqa: 'cancel-pickup-dont-cancel-button',
	};

	return (
		<Modal
			modalId={modalId}
			className="history-pickup cancel-pickup-modal"
			header="Cancel Pickup"
			primaryButton={primaryButton}
			secondaryButton={secondaryButton}
			size="small"
		>
			<div className="body">
				<p>
					Are you sure you want to cancel this pickup? This cannot be undone.
				</p>
			</div>
		</Modal>
	);
};

export default CancelPickupModal;
